import { useTranslation } from 'react-i18next'
import { useToggleRefinement } from 'react-instantsearch'
import { useTheme } from 'styled-components'
import { useAlgoliaFilters } from './AlgoliaSearchProvider'
import { NewFilterContainer, StyledFilterCheckbox } from './styles'

interface NewFilterProps {
  className?: string
  hasNeutralColor?: boolean
}

export const NewFilter = ({ className, hasNeutralColor }: NewFilterProps) => {
  const { t } = useTranslation('collection-filters')
  const { setIsSearchActive } = useAlgoliaFilters()
  const { value, refine } = useToggleRefinement({
    attribute: 'staff_pick_icon_id',
    on: 'new',
  })
  const theme = useTheme()

  const handleToggle = () => {
    setIsSearchActive(true)
    refine(value)
  }

  return (
    <NewFilterContainer className={className}>
      <StyledFilterCheckbox
        id="new-filter"
        uncheckedBoxColor={
          hasNeutralColor ? theme.colors.text.primary : undefined
        }
        onCheckedChange={handleToggle}
      >
        <label htmlFor="new-filter">{t('filterNew')}</label>
      </StyledFilterCheckbox>
    </NewFilterContainer>
  )
}
